import VSelectCourseTip from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectCourseTip', VSelectCourseTip),
};
